"use client"

import styled from "styled-components"
import {
  Badge,
  Card,
  CardHeader,
  Subtitle,
  Title,
  TitleGroup,
} from "./primitives"

const signals = [
  { label: "Job postings", detail: "AI & data roles", value: "+34%", tone: "optimal" as const },
  { label: "Insider buys", detail: "2 directors, 30d", value: "$4.1M", tone: "optimal" as const },
  { label: "Exec departures", detail: "VP Engineering", value: "1 new", tone: "alert" as const },
  { label: "Patent filings", detail: "Trailing 90d", value: "+12", tone: "caution" as const },
]

const toneColor = {
  optimal: "var(--color-optimal)",
  caution: "var(--color-caution)",
  alert: "var(--color-alert)",
}

const Timeline = styled.ul`
  margin: 1.25rem 0 0;
  padding: 0 0 0 0.5rem;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const Item = styled.li<{ $tone: keyof typeof toneColor }>`
  position: relative;
  padding-left: 1.25rem;
  border-left: 2px solid color-mix(in oklch, var(--color-border) 80%, transparent);

  &::before {
    content: "";
    position: absolute;
    left: -0.4375rem;
    top: 0.25rem;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 9999px;
    background: ${(p) => toneColor[p.$tone]};
    border: 2px solid var(--color-card);
  }
`

const ItemTop = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
`

const ItemLabel = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--color-card-foreground);
`

const ItemValue = styled.span<{ $tone: keyof typeof toneColor }>`
  font-family: var(--font-mono);
  font-size: 0.875rem;
  font-weight: 600;
  color: ${(p) => toneColor[p.$tone]};
`

const ItemDetail = styled.p`
  margin: 0.125rem 0 0;
  font-size: 0.75rem;
  color: var(--color-muted-foreground);
`

export function CorporateIntelCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Corporate intelligence</Title>
          <Subtitle>Alternative company signals</Subtitle>
        </TitleGroup>
        <Badge tone="optimal">Expanding</Badge>
      </CardHeader>

      <Timeline>
        {signals.map((s) => (
          <Item key={s.label} $tone={s.tone}>
            <ItemTop>
              <ItemLabel>{s.label}</ItemLabel>
              <ItemValue $tone={s.tone}>{s.value}</ItemValue>
            </ItemTop>
            <ItemDetail>{s.detail}</ItemDetail>
          </Item>
        ))}
      </Timeline>
    </Card>
  )
}

export default CorporateIntelCard
